import axiosInstance from "./instance";

// Get All Vendors by Status
const fetchTickets = async (page, status) => {

    // console.log(page);
    // console.log(status);

    const response = await axiosInstance.get('/tickets', {
        params: {
            page,
            status
        }
    });
    return response.data;
}

// Get Solo Order Details
const fetchTicket = async (ticketId) => {
    const response = await axiosInstance.get(`/tickets/solo`, {
        params: {
            ticketId
        }
    });
    return response.data;
}

const updateTicket = async (ticketId, status) => {
    console.log(ticketId);
    console.log(status);
    const response = await axiosInstance.put('/tickets', {
        ticketId,
        status
    });
    console.log(response.data);
    return response.data;
}

// const updatefeature = async (ticketId, status) => {
//     const response = await axiosInstance.post('/vendor/feature', {
//         ticketId,
//         status
//     });
//     console.log(response.data);
//     return response.data;
// }

export { fetchTickets, fetchTicket, updateTicket, };